import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { adminDashboardInfo } from "../services/adminServices";

const AdminDashboardInfo = () => {
  const [totalChats, setTotalChats] = useState("")
  const [botChats, setBotChats] = useState("")
  const [supportChats, setSupportChats] = useState("")
  const [totalUsers, setTotalUsers] = useState("")
  const [totalBots, setTotalBots] = useState("")
  const [activeBots, setActiveBots] = useState("")
  const [rejectedBots, setRejectedBots] = useState("")
  const [pendingBots, setPendingBots] = useState("")
  const [emptyBots, setEmptyBots] = useState("")
  const [tokensUsed, setTokensUsed] = useState("")

  const accessToken = useSelector((state) => state.auth.accessToken);
  useEffect(() => {
    const adminDashboard = async () => {
      const res = await adminDashboardInfo(accessToken)
      if (res?.ok) {
        setTotalChats(res?.data?.totalChats)
        setBotChats(res?.data?.botChats)
        setSupportChats(res?.data?.supportChats)
        setTotalUsers(res?.data?.totalUsers)
        setTotalBots(res?.data?.totalBots)
        setActiveBots(res?.data?.activeBots)
        setRejectedBots(res?.data?.rejectedBots)
        setPendingBots(res?.data?.pendingBots)
        setEmptyBots(res?.data?.emptyBots)
        setTokensUsed(res?.data?.tokensUsed)
      }
    }
    adminDashboard()
  }, [accessToken])
  return (
    <section className="  py-5 px-1 ">
      <div className="w-full flex  justify-center gap-4 px-6 text-white text-center">
        <div className="border border-[#1B4748] py-6 px-4 rounded-lg w-[320px]  flex justify-center gap-x-6 mb-10 bg-[#FFC505]">

          <p className="text-gray-800 text-lg ">تعداد توکن های مصرفی:</p>
          <p className="text-xl font-bold text-gray-950">{tokensUsed.toLocaleString('fa-IR')}</p>
        </div>
      </div>
      <h4 className="mb-sm-0 text-lg font-semibold grow text-gray-800 mt-6">
        اطلاعات مشتریان-گفتگوها :
      </h4>
      <div className="w-full flex  justify-center gap-4 px-1 text-white text-center mb-14 pt-3 flex-wrap">
        <div className=" border border-[#1B4748] py-6 px-4 rounded-lg w-[150px] bg-[#aadec5] ">
          <p className="text-2xl font-bold text-gray-950 ">{totalUsers.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-sm pt-3"> مشتریان</p>
        </div>
        <div className="border border-[#1B4748] py-6 px-1 rounded-lg w-[150px]  bg-[#f7e9ab]">
          <p className="text-2xl font-bold text-gray-950">{totalBots.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-sm pt-3">بات</p>
        </div>
        <div className="border border-[#1B4748] py-6 px-4 rounded-lg w-[150px]  bg-[#d8d9d8]">
          <p className="text-2xl font-bold text-gray-950">{botChats.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-sm pt-3"> گفتگو با بات</p>
        </div>
        <div className="border border-[#1B4748] py-6 px-1 rounded-lg w-[150px]  bg-[#f7d9ab]">
          <p className="text-2xl font-bold text-gray-950">{supportChats.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-sm pt-3"> گفتگو با پشتیبانی</p>
        </div>

      </div>


      <h4 className="mb-sm-0 text-lg font-semibold grow text-gray-800 mt-6">
        اطلاعات وضعیت بات ها :
      </h4>
      {/* <div className="w-full flex  justify-center gap-4 px-6 text-white text-center mb-1">
          <div className=" border border-[#1B4748] py-6 px-4 rounded-lg w-[150px] bg-[#aadec5]">
            <p className="text-2xl font-bold text-gray-950">{totalBots}</p>
            <p className="text-gray-800 text-sm">تعداد بات ها</p>
          </div>
        </div> */}
      <div className="hidden sm:flex justify-center flex-wrap gap-14 px-2 py-2 text-white text-center border border-[#1B4748]
        rounded-lg mt-5 max-w-[660px] m-auto ">
        {/* <div className=" py-6 px-4 rounded-lg ">
          <p className="text-[#FFC505] text-2xl font-bold">{totalBots}</p>
          <p className="text-gray-800 text-sm pt-3"> بات</p>
        </div> */}
        <div className="text-center py-6 px-4 ">
          <p className="text-[#FFC505] text-2xl font-bold">{activeBots.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-md pt-3 font-bold">   منتشر شده </p>
        </div>

        <div className="text-center py-6 px-4 ">
          <p className="text-[#FFC505] text-2xl font-bold">{pendingBots.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-md pt-3 font-bold">انتظار انتشار  </p>
        </div>
        <div className="text-center py-6 px-4 ">
          <p className="text-[#FFC505] text-2xl font-bold">{rejectedBots.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-md pt-3 font-bold">منتشر نشده </p>
        </div>

        <div className="text-center py-6 px-4 ">
          <p className="text-[#FFC505] text-2xl font-bold">{emptyBots.toLocaleString('fa-IR')}</p>
          <p className="text-gray-800 text-md pt-3 font-bold">ثبت نام اولیه </p>
        </div>

      </div>
      <div className="flex-col sm:hidden border border-[#1B4748] rounded-lg mt-5 max-w-[660px] m-auto text-white text-center">
        {[
          [{ label: "منتشر شده", count: activeBots }, { label: "انتظار انتشار", count: pendingBots }],
          [{ label: "منتشر نشده", count: rejectedBots }, { label: "ثبت نام اولیه", count: emptyBots }]
        ].map((row, rowIndex) => (
          <div key={rowIndex} className={`flex border-b border-gray-500 last:border-none`}>
            {row.map((item, colIndex) => (
              <div key={colIndex} className={`w-1/2 py-6 px-4 border-l border-gray-500 last:border-none`}>
                <p className="text-[#FFC505] text-2xl font-bold">{item.count.toLocaleString('fa-IR')}</p>
                <p className="text-gray-800 text-md pt-3 font-bold">{item.label}</p>
              </div>
            ))}
          </div>
        ))}
      </div>

    </section>
  );
};

export default AdminDashboardInfo;
